import React, { useState, useEffect, useMemo, useRef, useReducer } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import {
    Tooltip
} from '@material-ui/core';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { useTable } from "react-table";

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import AdvancesInvoicesAndComplementsService from "../../services/advances-invoices-and-complements.service";

import '../../styles/discountsAndInvoicesStyle.scss';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';



const initialState = {
    advancedDetailData :[],
    invoiceDetailData: [],
    complementsdDetailData: [],
    isLoadingAdvancedData : true,
    isLoadingInvoiceData : true,
    isLoadingComplementsData : true,
}

const reducer =  (state, action) =>{
    switch(action.type){
        case "SET_ADVANCED_DATA":
            return{...state, advancedDetailData: action.payload, isLoadingAdvancedData:false}
        case "SET_INVOICE_DATA":
            return{...state, invoiceDetailData: action.payload, isLoadingInvoiceData: false}
        
        case "SET_COMPLEMENTS_DATA":
            return{...state, complementsdDetailData: action.payload, isLoadingComplementsData:false}
        default: return{...state}
    }
}
export const AdvancesInvoicesAndComplementsDetailScreen = (props) => {

    const location = useLocation();
    const [{advancedDetailData, invoiceDetailData, complementsdDetailData, isLoadingAdvancedData, isLoadingInvoiceData, isLoadingComplementsData}, dispatch] = useReducer(reducer, initialState)
    const header = location.state && location.state?.dataHeader ? location.state.dataHeader : null;
    
    const currencySelected = 'es-Mx';

    const [headerData] = useState(header);
    const [isDownloadFile, setIsDownloadFile] = useState(false);

    const handleReturn = () => {
        props.history.push({
            pathname: `/operation/advances-invoices-and-complements`,
            state: { reloadFilters: true }
        });
        window.location.reload();
    }

    const downloadFile = () =>{
        const paramsHeader = JSON.parse(localStorage.getItem('headerFilter'));
        setIsDownloadFile(true)
        const fileName = `consulta_detalle_factura_${paramsHeader.an8}`;
        console.log("dsd",{})
        AdvancesInvoicesAndComplementsService.downloadAdvancesInvoiceConsultationDetailXlsx({invoiceConsultationHeaderDtoList:[header],...advancedDetailData, ...invoiceDetailData, ...complementsdDetailData}, paramsHeader.an8).then((response)=>{
          const byteString = window.atob(response.split(',')[1]);
          const mimeString = response.split(',')[0].split(':')[1].split(';')[0];
    
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i)
          }
    
          const dataBlob = new Blob([ab], { type: mimeString });
    
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
            setIsDownloadFile(false);
            return
          }
    
          const url = window.URL.createObjectURL(dataBlob);
          const link = document.createElement('a');
          link.href = url
          link.setAttribute('download', `${fileName}.xls`);
          document.body.appendChild(link);
          link.click();
          link.remove();
    
          setIsDownloadFile(false);
        },
        (error)=>{
          setIsDownloadFile(false);
          actionErrorConnection(error, 'Error al descargar archivo xls.');
        });
    }
    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="row flex-nowrap p-0 m-0">
                    <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                        <SidebarMenu />
                    </div>
                    <div className="col p-0 ms-1 me-1">
                        <NavTopMenu />
                        <div className="container ps-3 pe-3 container-size">
                            <div className="row base-container ">
                                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                                    <span>Consulta de facturas - Detalle</span>
                                </div>
                                {
                            isDownloadFile ?
                              <Tooltip title="Descargargando..." placement="top-start" arrow>
                                <div className="custom-icon-loading me-1">
                                  <i className="fas fa-spinner fa-spin"></i>
                                </div>
                              </Tooltip>
                              :
                              <Tooltip title="Descargar resultados" placement="top-start" arrow>
                                <div>
                                  <button
                                    className="btn custom-btn-icons"
                                    onClick={()=>downloadFile()}
                                    type="button"
                                    disabled={isLoadingInvoiceData || isLoadingAdvancedData || isLoadingComplementsData}
                                  >
                                    <i className="fas fa-download"></i>
                                  </button>
                                </div>
                              </Tooltip>
                          }
                                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className=" d-flex justify-content-end">
                                                <Tooltip title="Regresar" placement="top-start" arrow>
                                                    <button
                                                        className="btn custom-btn-icons"
                                                        type="button"
                                                        onClick={() => handleReturn()}
                                                    >
                                                        <i className="fas fa-chevron-left"></i>
                                                    </button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row pt-3 pb-3'>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Tipo:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.type ? headerData.type : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">No. factura:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.invoiceNumber ? headerData.invoiceNumber : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Fecha factura:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.dateInvoice ? headerData?.dateInvoice : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Serie:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.serie ? headerData?.serie : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Concepto descuento:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.discountConcept ? headerData?.discountConcept : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Forma pago:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.wayToPay ? headerData?.wayToPay : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Método pago:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">{headerData?.paymentMethod ? headerData?.paymentMethod : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='row'>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Monto sin IVA:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">$ {headerData?.amountWithoutVat ? parseFloat(headerData?.amountWithoutVat).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Monto descuento:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">$ {headerData?.discountAmount ? parseFloat(headerData?.discountAmount).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Monto menos descuento:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">$ {headerData?.amountLessDiscount ? parseFloat(headerData?.amountLessDiscount).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">IVA:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">$ {headerData?.vat ? parseFloat(headerData?.vat).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2
                                                        }) : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className=" row">
                                                        <div className="col-6 col-md-5">
                                                            <span className="invoice-header-title">Total con IVA:</span>
                                                        </div>
                                                        <div className="col-6 col-md-7">
                                                            <span className="invoice-header-info">$ {headerData?.totalWithVat ? parseFloat(headerData?.totalWithVat).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2
                                                        }) : '---'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                        <span className="invoice-detail-title">Ventas</span>
                                            <AdvancesDetailScreen header={headerData}  dispatchReducer={dispatch} />
                                        </div>
                                        <div className="col-12">
                                        <span className="invoice-detail-title">Descuentos</span>
                                            <InvoicesDetailScreen header={headerData} dispatchReducer={dispatch}  />
                                        </div>
                                        <div className="col-12">
                                        <span className="invoice-detail-title">Anticipos</span>
                                            <ComplementsDetailScreen header={headerData} dispatchReducer={dispatch} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

AdvancesInvoicesAndComplementsDetailScreen.propTypes = {
    row: PropTypes.any,
    getToggleAllRowsSelectedProps: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string
        })
    }),
};

export const AdvancesDetailScreen = ({header, dispatchReducer}) => {

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const dispatch = useDispatch();
    const history = useHistory();

    const currencySelected = 'es-Mx';

    const [isLoadingData, setIsLoadingData] = useState(false);
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);


    const [dataDetail, setDataDetail] = useState([]);

    const detailRef = useRef();

    detailRef.current = dataDetail;

    const columns = useMemo(
        () => [
            {
                Header: "Concepto",
                accessor: "concept",
                enableResizing: false,
                minWidth: 200,
                width: 200,
                maxWidth: 200
            },
            {
                Header: "Tipo",
                accessor: "type",
                enableResizing: false,
                minWidth: 100,
                width: 100,
                maxWidth: 100
            },
            {
                Header: "Número",
                accessor: "number",
                enableResizing: false,
                minWidth: 100,
                width: 100,
                maxWidth: 100
            },
            {
                Header: "Monto Sin IVA",
                accessor: "amountWithoutVat",
                enableResizing: false,
                minWidth: 200,
                width: 200,
                maxWidth: 200
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns: columns,
        data: dataDetail,
    });
 
    useEffect(() => {
        onSubmit(header);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    /**
  * Crea el onjeto a enviar en la petición de busqueda
  * @param {string} data - información del formulario
  * @author alSanchez - ETE
  * @version 1.0.0 - Enero 2024
  */
    const onSubmit = (data) => {
        setDataDetail([]);

        setIsLoadingData(true);
        setIsErrorResponse(false);

        const params = data;
        console.log(params)
        getDetailHeaderByFilters(params);

    };

    /**
  * Recupera lcabecero por filtros
  * @param {object} params - filtros para la busqueda
  * @author alSanchez - ETE
  * @version 1.0.0 - Enero 2024
  */
    const getDetailHeaderByFilters = (params) => {
        AdvancesInvoicesAndComplementsService.getAdvancesDetail(params)
            .then((response) => {
                if (!response.data || response.message?.length > 1) {
                    setErrorResponse(response.message);
                    setDataDetail([]);
                    setIsErrorResponse(true);
                } else {
                    setDataDetail(response.data?.details ? response.data?.details : []);
                    dispatchReducer({type:"SET_ADVANCED_DATA", payload: response.data ? {invoiceConsultationResponseSales:[response.data]} : [] })
                    setIsErrorResponse(false);
                }
                setIsLoadingData(false);

            })
            .catch((error) => {
                setDataDetail([]);
                setIsLoadingData(false);
                if (error.response) {

                    setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    }
                } else {
                    setErrorResponse(error);
                    actionErrorConnection(error);
                }
                setIsErrorResponse(true);

            });
    }
    return (
        <>
            <table
                className=""
                {...getTableProps()}
            >
                <thead>
                    {headerGroups.map((headerGroup, i) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className="element-header-content border-content " key={i}>
                            {headerGroup.headers.map((column, j) => (
                                <th {...column.getHeaderProps({
                                    style: { minWidth: column.minWidth, width: column.width },
                                })}
                                    className="border-element header-element header-text pt-3 pb-3" key={j}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={row.getRowProps().key}>
                                <tr className="element-row border-content">
                                    {row.cells.map((cell, i) => {
                                        return (
                                            <td className="border-element content-text padding-row-actions"
                                                key={i}
                                                {...cell.getCellProps({
                                                    style: {
                                                        minWidth: cell.column.minWidth,
                                                        width: cell.column.width,
                                                      },
                                                })}>
                                                {
                                                    (cell.column.Header === 'Monto Sin IVA') ?
                                                        `$ ${parseFloat(cell.value).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}` : cell.render("Cell")
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
            {(isErrorResponse) &&
                <div className="error-message border-content pt-4 pb-4">
                    <span className="">{errorResponse && errorResponse.toString()}</span>
                </div>}
            {(isLoadingData) &&
                <div className=" border-content pt-4 pb-4 custom-icon-loading">
                    <i className="fas fa-spinner fa-spin"></i>
                </div>}
            {(dataDetail.length === 0 && !isLoadingData && !isErrorResponse) &&
                <div className="element-row-message border-content pt-4 pb-4 ">
                    <span>No se encontraron ventas relacionadas a la factura.</span>
                </div>}
        </>
    )
};

AdvancesDetailScreen.propTypes = {
    header: PropTypes.object,
    row: PropTypes.any,
    getToggleAllRowsSelectedProps: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string
        })
    }),
    dispatchReducer:PropTypes.any
};

export const InvoicesDetailScreen = ({header,dispatchReducer}) => {

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const dispatch = useDispatch();
    const history = useHistory();

    const currencySelected = 'es-Mx';

    const [isLoadingData, setIsLoadingData] = useState(false);
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);

    const [dataDetail, setDataDetail] = useState([]);

    const detailRef = useRef();

    detailRef.current = dataDetail;

    const columns = useMemo(
        () => [
            {
                Header: "Concepto",
                accessor: "concept",
                enableResizing: false,
                minWidth: 200,
                width: 200,
                maxWidth: 200
            },
            {
                Header: "Tipo",
                accessor: "type",
                enableResizing: false,
                minWidth: 100,
                width: 100,
                maxWidth: 100
            },
            {
                Header: "Número",
                accessor: "number",
                enableResizing: false,
                minWidth: 100,
                width: 100,
                maxWidth: 100
            },
            {
                Header: "Monto Sin IVA",
                accessor: "amountWithoutVat",
                enableResizing: false,
                minWidth: 200,
                width: 200,
                maxWidth: 200
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns: columns,
        data: dataDetail,
    });

    useEffect(() => {
        onSubmit(header);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    /**
  * Crea el onjeto a enviar en la petición de busqueda
  * @param {string} data - información del formulario
  * @author alSanchez - ETE
  * @version 1.0.0 - Enero 2024
  */
    const onSubmit = (data) => {
        setDataDetail([]);

        setIsLoadingData(true);
        setIsErrorResponse(false);

        const params = data;
        getDetailHeaderByFilters(params);

    };

    /**
  * Recupera lcabecero por filtros
  * @param {object} params - filtros para la busqueda
  * @author alSanchez - ETE
  * @version 1.0.0 - Enero 2024
  */
    const getDetailHeaderByFilters = (params) => {
        AdvancesInvoicesAndComplementsService.getInvoicesDetail(params)
            .then((response) => {
                if (!response.data || response.message?.length > 1) {
                    setErrorResponse(response.message);
                    setIsErrorResponse(true);
                } else {
                    setDataDetail(response.data?.details ? response.data?.details : []);
                    dispatchReducer({type:"SET_INVOICE_DATA", payload: response.data?.details ? { invoiceConsultationResponseDiscuount:[ response.data]} : []})
                    setIsErrorResponse(false);
                }
                setIsLoadingData(false);

            })
            .catch((error) => {
                setDataDetail([]);
                setIsLoadingData(false);
                if (error.response) {

                    setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    }
                } else {
                    setErrorResponse(error);
                    actionErrorConnection(error);
                }
                setIsErrorResponse(true);

            });
    }

    return (
        <>
            <table
                className=""
                {...getTableProps()}
            >
                <thead>
                    {headerGroups.map((headerGroup, i) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className="element-header-content border-content " key={i}>
                            {headerGroup.headers.map((column, j) => (
                                <th {...column.getHeaderProps({
                                    style: { minWidth: column.minWidth, width: column.width },
                                })}
                                    className="border-element header-element header-text pt-3 pb-3" key={j}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={row.getRowProps().key}>
                                <tr className="element-row border-content">
                                    {row.cells.map((cell, i) => {
                                        return (
                                            <td className="border-element content-text padding-row-actions"
                                                key={i}
                                                {...cell.getCellProps({
                                                    style: {
                                                        minWidth: cell.column.minWidth,
                                                        width: cell.column.width,
                                                      },
                                                })}>
                                                {
                                                    (cell.column.Header === 'Monto Sin IVA') ?
                                                        `$ ${parseFloat(cell.value).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}` : cell.render("Cell")
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
            {(isErrorResponse) &&
                <div className="error-message border-content pt-4 pb-4">
                    <span className="">{errorResponse && errorResponse.toString()}</span>
                </div>}
            {(isLoadingData) &&
                <div className=" border-content pt-4 pb-4 custom-icon-loading">
                    <i className="fas fa-spinner fa-spin"></i>
                </div>}
            {(dataDetail.length === 0 && !isLoadingData && !isErrorResponse) &&
                <div className="element-row-message border-content pt-4 pb-4 ">
                    <span>No se encontraron descuentos relacionados a la factura.</span>
                </div>}
        </>
    )
};

InvoicesDetailScreen.propTypes = {
    header: PropTypes.object,
    row: PropTypes.any,
    getToggleAllRowsSelectedProps: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string
        })
    }),
    dispatchReducer: PropTypes.any
};

export const ComplementsDetailScreen = ({header, dispatchReducer}) => {

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const dispatch = useDispatch();
    const history = useHistory();

    const currencySelected = 'es-Mx';

    const [isLoadingData, setIsLoadingData] = useState(false);
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);

    const [dataDetail, setDataDetail] = useState({});

    const detailRef = useRef();

    detailRef.current = dataDetail;

    const columns = useMemo(
        () => [
            {
                Header: "Concepto",
                accessor: "concept",
                enableResizing: false,
                minWidth: 200,
                width: 200,
                maxWidth: 200
            },
            {
                Header: "Tipo",
                accessor: "type",
                enableResizing: false,
                minWidth: 100,
                width: 100,
                maxWidth: 100
            },
            {
                Header: "Número",
                accessor: "number",
                enableResizing: false,
                minWidth: 100,
                width: 100,
                maxWidth: 100
            },
            {
                Header: "Monto Sin IVA",
                accessor: "amountWithoutVat",
                enableResizing: false,
                minWidth: 200,
                width: 200,
                maxWidth: 200
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns: columns,
        data: dataDetail?.detail ? dataDetail?.detail : []
    });

    useEffect(() => {
        onSubmit(header);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    /**
  * Crea el onjeto a enviar en la petición de busqueda
  * @param {string} data - información del formulario
  * @author alSanchez - ETE
  * @version 1.0.0 - Enero 2024
  */
    const onSubmit = (data) => {
        setDataDetail([]);

        setIsLoadingData(true);
        setIsErrorResponse(false);

        const params = data;
        getDetailInvoices(params);
    };

    const getDetailInvoices = (params) => {
        AdvancesInvoicesAndComplementsService.getInvoicesDetail(params)
            .then((response) => {
                getDetailAdvances(params, response.data); 
            })
            .catch((error) => {
                setDataDetail({
                    detail: [],
                    vat: "0.00"});
                setIsLoadingData(false);
                if (error.response) {

                    setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);
                    
                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    }
                } else {
                    setErrorResponse(error);
                    actionErrorConnection(error);
                }
                setIsErrorResponse(true);

            });
    }

    const getDetailAdvances = (params, InvoiceDetail) => {
        AdvancesInvoicesAndComplementsService.getAdvancesDetail(params)
            .then((response) => {
                
                getDetailHeaderByFilters(params, InvoiceDetail, response.data);
                
            })
            .catch((error) => {
                setDataDetail({
                    detail: [],
                    vat: "0.00"});
                setIsLoadingData(false);
                if (error.response) {

                    setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    }
                } else {
                    setErrorResponse(error);
                    actionErrorConnection(error);
                }
                setIsErrorResponse(true);

            });
    }

    /**
  * Recupera lcabecero por filtros
  * @param {object} params - filtros para la busqueda
  * @author alSanchez - ETE
  * @version 1.0.0 - Enero 2024
  */
    const getDetailHeaderByFilters = (params, invoiceDetail, advanceDetail) => {

        const paramsHeader = JSON.parse(localStorage.getItem('headerFilter'));
        
        let advanceSum = advanceDetail.amountWithoutVatTotal ? advanceDetail.amountWithoutVatTotal : 0;
        let invoiceSum = invoiceDetail.amountWithoutVatTotal ? invoiceDetail.amountWithoutVatTotal : 0;

        AdvancesInvoicesAndComplementsService.getComplementsDetail(params, paramsHeader.an8, invoiceSum, advanceSum)
            .then((response) => {
                if ( response.message?.length > 1) {
                    setErrorResponse(response.message);
                    setIsErrorResponse(true);
                    setDataDetail({
                        detail: [],
                        vat: "0.00"});
                } else {
                    setDataDetail({
                        detail: response.data?.detail ? response.data?.detail : [],
                        vat: response.data?.vat ? response.data?.vat : "0.00"});
                    setIsErrorResponse(false);

                    dispatchReducer({type:"SET_COMPLEMENTS_DATA", payload:response.data?.detail ? {invoiceConsultationAnticipationResponse: [response.data]} : []})
                    
                }
                setIsLoadingData(false);
            })
            .catch((error) => {
                setDataDetail({
                    detail: [],
                    vat: "0.00"});
                setIsLoadingData(false);
                if (error.response) {

                    setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    }
                } else {
                    setErrorResponse(error);
                    actionErrorConnection(error);
                }
                setIsErrorResponse(true);

            });
    }

    return (
        <>
            <table
                className=""
                {...getTableProps()}
            >
                <thead>
                    {headerGroups.map((headerGroup, i) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className="element-header-content border-content " key={i}>
                            {headerGroup.headers.map((column, j) => (
                                <th {...column.getHeaderProps({
                                    style: { minWidth: column.minWidth, width: column.width },
                                })}
                                    className="border-element header-element header-text pt-3 pb-3" key={j}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={row.getRowProps().key}>
                                <tr className="element-row border-content">
                                    {row.cells.map((cell, i) => {
                                        return (
                                            <td className="border-element content-text padding-row-actions"
                                                key={i}
                                                {...cell.getCellProps({
                                                    style: {
                                                        minWidth: cell.column.minWidth,
                                                        width: cell.column.width,
                                                      },
                                                })}>
                                                {
                                                    (cell.column.Header === 'Monto Sin IVA' || cell.column.Header === 'Total sin IVA') ?
                                                        `$ ${parseFloat(cell.value).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}` : cell.render("Cell")
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
            {(isErrorResponse) &&
                <div className="error-message border-content pt-4 pb-4">
                    <span className="">{errorResponse && errorResponse.toString()}</span>
                </div>}
            {(isLoadingData) &&
                <div className=" border-content pt-4 pb-4 custom-icon-loading">
                    <i className="fas fa-spinner fa-spin"></i>
                </div>}
            {(dataDetail.detail?.length === 0 && !isLoadingData && !isErrorResponse) &&
                <div className="element-row-message border-content pt-4 pb-4 ">
                    <span>No se encontraron anticipos relacionados a la factura.</span>
                </div>}
                <div className='d-flex justify-content-end pt-3 pb-3'>
                    <div className="col-md-4">
                        <div className=" row">
                            <div className="col-6 col-md-5">
                                <span className="invoice-footer-detail-title">Total sin IVA:</span>
                            </div>
                            <div className="col-6 col-md-7">
                                <span className="invoice-footer-detail-info">$ {dataDetail.vat > 0 ? parseFloat(dataDetail.vat).toLocaleString(currencySelected,{
                                                            minimumFractionDigits: 2
                                                        }) : '0.00'}</span>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    )
};

ComplementsDetailScreen.propTypes = {
    header: PropTypes.object,
    row: PropTypes.any,
    getToggleAllRowsSelectedProps: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string
        })
    }),
    dispatchReducer: PropTypes.any
};